// utils/qapPreviewCsv.js — the QAP tab's preview table as CSV, for review in
// a spreadsheet. NOT a BIR file and not the DAT layout (that is qapLayout.js).
import { formatCentavos } from './datCommon';
import { qapPreviewRows } from './qapDat';

const pct = (bp) => formatCentavos(bp); // 500 bp → "5.00"

/** Preview → CSV (for review only — not a BIR file). */
export function qapPreviewCsv(data) {
  const esc = (v) => {
    const s = String(v ?? '');
    return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const money = (c) => (Number.isInteger(c) ? formatCentavos(c) : '');
  const lines = [
    ['Seq', 'Payee', 'TIN', 'Branch', 'ATC', 'Tax base', 'Rate %', 'Tax withheld'],
    ...qapPreviewRows(data).map((r) => [
      r.seq, r.payee, r.tin9 || '', r.branchCode || '', r.atcCode, money(r.taxBaseCentavos),
      Number.isInteger(r.rateBasisPoints) ? pct(r.rateBasisPoints) : '', money(r.taxWithheldCentavos),
    ]),
    ['', 'Total', '', '', '', money(data?.control?.totalTaxBaseCentavos), '', money(data?.control?.totalTaxWithheldCentavos)],
  ];
  return lines.map((l) => l.map(esc).join(',')).join('\n') + '\n';
}

export function downloadQapPreviewCsv(data, filename) {
  const blob = new Blob([qapPreviewCsv(data)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
